import React, { useEffect, useState } from "react"
import SupplierList from "../../../supplier/SupplierList/SupplierList"
import * as styles from "./LandingPageSuppliers.module.scss"
import useMediaQuery from "@lib/useMediaQuery"
import fetchLambda from "@data/fetchLambda"
import lambdas from "@data/lambdas"
import Button from "@components/objects/Button/Button"
import Section from "@components/structure/Section/Section"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"

const { SUPPLIER_SEARCH } = lambdas[process.env.NEXT_PUBLIC_ENV]

const LandingPageSuppliers = (props) => {
  const [suppliers, setSuppliers] = useState(null)

  // Resize control
  const isMobile = useMediaQuery(800)

  useEffect(async () => {
    let isActive = true
    if ( props.suppliers && props.suppliers.length) {
      setSuppliers(props.suppliers)
    } else {
      const searchParams = {
        category: props.category,
        first: props.layout === "grid" ? 9 : 8,
        orderBy: "rank",
        order: "DESC",
        skip: Math.floor(Math.random() * 10),
      }
      if (props.service) {
        searchParams.services = [`${props.service}`]
      }
      const response = await fetchLambda(SUPPLIER_SEARCH, {
        params: searchParams,
      })
      if (isActive && response.ok) {
        setSuppliers(response.data.result.allSuppliers)
      }
    }
    return () => (isActive = false)
  }, [props.category, props.layout, props.service, props.suppliers])

  return (
    <div ref={props.scrollRef}>
      <Section className={`${styles.LandingPageSuppliers} ${props.layout === "grid" ? styles.featured : ""}`}>
        <SiteWrapper className={styles.wrapper}>
          {props.title ? (
            <div className={styles.header}>
              <h3 className={styles.subtitle}>{props.subtitle}</h3>
              <h2 className={styles.title}>{props.title}</h2>
            </div>
          ) : null}
          <SupplierList
            className={props.layout === "grid" ? styles.grid : styles.wide}
            hideNote={props.layout === "grid" && !isMobile}
            hideIcons={props.layout === "grid" && !isMobile}
            isSlider={props.layout !== "grid" && isMobile}
            suppliers={suppliers}
          />
          {props.title ? (
            <Button
              className={styles.cta}
              color="pink"
              design="outline"
              text="Start Browsing"
              link={`/suppliers-search/?category=${props.category}`}
            />
          ) : null}
        </SiteWrapper>
      </Section>
    </div>
  )
}

export default LandingPageSuppliers
